import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable react/forbid-elements */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { getTruncationCss } from '../../utils';
import { ensureBuildingSuggestion } from '../../../../utils/types';
import { EInputType } from '../../../../types';
import * as styles from '../../styles.css';
import { ItemContent } from '../ItemContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BuildingsSuggestionContent = function BuildingsSuggestionContent(props) {
  var item = props.item,
    onLinkClick = props.onLinkClick,
    inputType = props.inputType,
    itemsTruncation = props.itemsTruncation;
  var buildingSuggestion = ensureBuildingSuggestion(item);
  var shouldRenderLink = !(inputType === EInputType.mobile || inputType === EInputType.tablet);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['building-name'], getTruncationCss(itemsTruncation))), {}, {
      "data-testid": "BuildingSuggestion",
      children: /*#__PURE__*/_jsx("span", {
        className: getTruncationCss(itemsTruncation, true),
        children: /*#__PURE__*/_jsx(ItemContent, {
          item: item
        })
      })
    })), /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['address'], styles['trunc_1'])), {}, {
      children: buildingSuggestion.address
    })), buildingSuggestion.link && shouldRenderLink &&
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-target-blank
    _jsx("a", {
      className: styles['link'],
      href: buildingSuggestion.link,
      target: "_blank",
      onClick: onLinkClick,
      children: /*#__PURE__*/_jsx("i", {
        className: styles['link-icon'],
        children: /*#__PURE__*/_jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          children: /*#__PURE__*/_jsx("path", {
            fill: "#2B87DB",
            fillRule: "evenodd",
            d: "M12 .5V5h-1V1H7V0h5v.5zM0 1h1v10H0V1zm1 11v-1h10v1H1zM5 0v1H1V0h4zm7 11h-1V7h1v4zM10 1h1v1h-1V1zM9 2h1v1H9V2zM8 3h1v1H8V3zM7 4h1v1H7V4zM6 5h1v1H6V5z"
          })
        })
      })
    })]
  });
};